export default __webpack_public_path__ + "static/media/21st february.d359bb3e.png";